module.exports = __webpack_public_path__ + "media/images/nita_online_payment_steps/3-dbdd09dbeac36cb269faab9a2c290e65.png";